// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"97c79422","125":"80ec17f8","363":"6deb5d64","366":"5e07a0bf","391":"a2ebfaa3","394":"20a36125","410":"8c7938bb","453":"9be3cf52","732":"2c89a2eb","866":"58bb16d6","958":"b2abc1bf"}[chunkId] + ".chunk.js";
};